import { render, staticRenderFns } from "./UserRoleDetail.vue?vue&type=template&id=7284dd35"
import script from "./UserRoleDetail.vue?vue&type=script&lang=js"
export * from "./UserRoleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports